export class CostReviewSiteQualificationSa {
    customerAllowsData: number = 0
    monitoredEquipmentIntegrated: number = 0;
    thirdPartyIntegrated: number = 0;
    panelHasSpareCapacity: number = 0;
    isDigitalServiceAvailable: boolean = false;
}